(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-svc-catalog"] && !Shopify.designMode) return;
  try {
    
(function initSvcCarousel() {
  const w = document.getElementById('svcCarousel');
  const t = document.getElementById('svcCarouselTrack');
  if (!w || !t) return;
  const prev = w.querySelector('[data-dir="prev"]');
  const next = w.querySelector('[data-dir="next"]');
  const bar = document.getElementById('svcBar');
  const barWrap = bar?.parentElement;
  const step = () => (t.firstElementChild?.offsetWidth || 220) + 20;

  const update = () => {
    const max = Math.max(1, t.scrollWidth - t.clientWidth);
    const ratio = Math.min(1, Math.max(0, t.scrollLeft / max));
    if (bar && barWrap) {
      const barW = bar.offsetWidth;
      const trackW = barWrap.offsetWidth;
      const available = Math.max(0, trackW - barW);
      bar.style.transform = `translateX(${available * ratio}px)`;
    }
    if (prev) prev.disabled = t.scrollLeft <= 4;
    if (next) next.disabled = t.scrollLeft >= max - 4;
  };

  prev?.addEventListener('click', () => t.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
  next?.addEventListener('click', () => t.scrollBy({ left: step() * 2, behavior: 'smooth' }));
  t.addEventListener('scroll', update);
  window.addEventListener('resize', update);

  if (barWrap) {
    let dragging = false;
    const apply = (clientX) => {
      const rect = barWrap.getBoundingClientRect();
      const indicatorW = bar.offsetWidth;
      const available = Math.max(1, rect.width - indicatorW);
      const x = Math.min(available, Math.max(0, clientX - rect.left - indicatorW / 2));
      const ratio = x / available;
      const max = Math.max(1, t.scrollWidth - t.clientWidth);
      t.scrollLeft = ratio * max;
    };
    const onDown = (e) => {
      dragging = true;
      barWrap.classList.add('dragging');
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      apply(x);
      if (e.cancelable) e.preventDefault();
    };
    const onMove = (e) => {
      if (!dragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      apply(x);
      if (e.cancelable) e.preventDefault();
    };
    const onUp = () => {
      dragging = false;
      barWrap.classList.remove('dragging');
    };
    barWrap.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    barWrap.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
  }

  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swipe-lp"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function bootstrap() {
      attachShopifyEditorListeners();
      var roots = document.querySelectorAll('.swipe-lp');
      if (!roots.length) return;
      Array.prototype.forEach.call(roots, function(root) { initSection(root); });
    }

    function attachShopifyEditorListeners() {
      if (window.__swipeLpEditorListenersAttached) return;
      window.__swipeLpEditorListenersAttached = true;

      document.addEventListener('shopify:section:load', function(e) {
        var sectionEl = e.target;
        if (!sectionEl) return;
        var roots = sectionEl.querySelectorAll('.swipe-lp');
        Array.prototype.forEach.call(roots, function(root) { initSection(root); });
      });

      document.addEventListener('shopify:section:unload', function(e) {
        var unloadedId = e.detail && e.detail.sectionId;
        if (!unloadedId) return;
        var orphan = document.querySelector('.slide-indicator[data-section-id="' + unloadedId + '"]');
        if (orphan && orphan.parentElement) orphan.parentElement.removeChild(orphan);
      });
    }

    function initSection(fullpageRoot) {
    const section = fullpageRoot.closest('.shopify-section') || fullpageRoot.parentElement || fullpageRoot;

    const slideNodes = Array.from(fullpageRoot.querySelectorAll('.swipe-lp__slide'));
    const slides = slideNodes.map((slide, idx) => {
      const buttonLink = slide.dataset.buttonLink ? slide.dataset.buttonLink.trim() : '';
      const variantId = slide.dataset.variantId ? slide.dataset.variantId.trim() : '';
      return {
        id: slide.dataset.slideId || String(idx + 1),
        type: slide.dataset.slideType || 'image',
        title: slide.dataset.slideTitle || '',
        buttonType: slide.dataset.buttonType || 'none',
        buttonText: slide.dataset.buttonText || '',
        buttonLink,
        variantId,
        element: slide
      };
    });

    if (!slides.length) return;

    const DEFAULT_BUTTON_TEXT = '購入する';
    const VIDEO_REPLAY_DELAY = 10000;//再生待機時間
    const slideViewTimes = {};
    const videoReplayTimers = new WeakMap();
    let hasUserInteracted = false;
    let pendingPlayVideo = null;

    function getVideoSlide(video) {
      return video ? video.closest('.swipe-lp__slide') : null;
    }

    function clearVideoReplayTimer(video) {
      if (!video) return;
      const timerId = videoReplayTimers.get(video);
      if (timerId) {
        clearTimeout(timerId);
        videoReplayTimers.delete(video);
      }
    }

    function pauseAndResetVideo(video) {
      if (!video) return;
      clearVideoReplayTimer(video);
      video.pause();
      video.currentTime = 0;
    }

    function scheduleVideoReplay(video) {
      if (!video) return;
      clearVideoReplayTimer(video);
      const slide = getVideoSlide(video);
      if (!slide || !slide.classList.contains('active')) return;

      const timerId = setTimeout(() => {
        videoReplayTimers.delete(video);
        if (!slide.classList.contains('active')) return;
        video.currentTime = 0;
        requestVideoPlay(video);
      }, VIDEO_REPLAY_DELAY);

      videoReplayTimers.set(video, timerId);
    }

    function trackEvent(eventName, eventParams) {
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', eventName, eventParams);
      }

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: eventName,
          ...eventParams
        });
      }
    }

    function ensureSlideIndicator() {
      const sectionId = fullpageRoot.dataset.sectionId || '';
      const indicatorSelector = '.slide-indicator[data-section-id="' + sectionId + '"]';
      let indicator = sectionId ? document.querySelector(indicatorSelector) : section.querySelector('.slide-indicator');
      if (!indicator) {
        indicator = document.createElement('div');
        indicator.className = 'slide-indicator';
        if (sectionId) {
          indicator.classList.add('slide-indicator-' + sectionId);
          indicator.dataset.sectionId = sectionId;
        }
        indicator.innerHTML = '<span class="slide-indicator__current">1</span><span class="slide-indicator__divider"></span><span class="slide-indicator__total"></span>';
        document.body.appendChild(indicator);
      }
      // body 直下では section スコープの CSS カスタムプロパティを継承できないため、
      // fullpageRoot から実値を取り出して indicator に直接コピーする
      try {
        const rootStyle = window.getComputedStyle(fullpageRoot);
        const indicatorColor = rootStyle.getPropertyValue('--indicator-color').trim();
        const maxWidth = rootStyle.getPropertyValue('--max-width').trim();
        if (indicatorColor) indicator.style.setProperty('--indicator-color', indicatorColor);
        if (maxWidth) indicator.style.setProperty('--max-width', maxWidth);
      } catch (e) {}
      return indicator;
    }

    function updateSlideIndicator(slideIndex) {
      const indicator = ensureSlideIndicator();
      const currentEl = indicator.querySelector('.slide-indicator__current');
      const totalEl = indicator.querySelector('.slide-indicator__total');
      if (currentEl) currentEl.textContent = String(slideIndex + 1);
      if (totalEl) totalEl.textContent = String(slides.length);
    }

    function trackSlideView(slideIndex) {
      const slide = slides[slideIndex];
      if (!slide) return;
      slideViewTimes[slideIndex] = Date.now();
      trackEvent('slide_view', {
        slide_number: slideIndex + 1,
        slide_title: slide.title || `Slide ${slideIndex + 1}`,
        slide_id: slide.id,
        slide_type: slide.type
      });
    }

    function trackSlideDuration(slideIndex) {
      const slide = slides[slideIndex];
      if (!slide) return;

      const viewTime = slideViewTimes[slideIndex];
      let durationSeconds = 0;

      if (viewTime) {
        durationSeconds = Math.round((Date.now() - viewTime) / 100) / 10;
        delete slideViewTimes[slideIndex];
      }

      trackEvent('slide_duration', {
        slide_number: slideIndex + 1,
        slide_title: slide.title || `Slide ${slideIndex + 1}`,
        slide_id: slide.id,
        slide_type: slide.type,
        duration_seconds: durationSeconds
      });
    }

    function trackLinkClick(slideIndex, linkUrl) {
      const slide = slides[slideIndex];
      if (!slide) return;

      trackEvent('slide_link_click', {
        slide_number: slideIndex + 1,
        slide_title: slide.title || `Slide ${slideIndex + 1}`,
        slide_id: slide.id,
        link_url: linkUrl
      });
    }

    function trackCartAdd(slideIndex, variantId) {
      const slide = slides[slideIndex];
      if (!slide) return;

      trackEvent('slide_cart_add', {
        slide_number: slideIndex + 1,
        slide_title: slide.title || `Slide ${slideIndex + 1}`,
        slide_id: slide.id,
        variant_id: variantId
      });
    }

    function openThemeCartUI() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart-notification:show', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart:open-drawer', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('cart-notification:show', { bubbles: true }));
    }

    function addToCart(variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('cart_add_failed');
          }
          return response.json();
        })
        .then(() => {
          openThemeCartUI();
          setTimeout(() => {
            const drawerOpen = document.querySelector('cart-drawer[open], .cart-drawer.is-open, .drawer--active');
            if (!drawerOpen) {
              window.location.href = '/cart';
            }
          }, 1500);
        })
        .catch(() => {
          window.location.href = '/cart';
        });
    }

    function requestVideoPlay(video) {
      if (!video) return;
      clearVideoReplayTimer(video);
      video.muted = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          pendingPlayVideo = video;
        });
      }
    }

    function markUserInteraction() {
      if (hasUserInteracted) return;
      hasUserInteracted = true;
      const videos = section.querySelectorAll('.video__wrap video');
      videos.forEach((vid, idx) => {
        const dataSrc = vid.getAttribute('data-src');
        const currentSrc = vid.getAttribute('src');
        if (!currentSrc && dataSrc) {
          vid.setAttribute('src', dataSrc);
          vid.load();
        }
        vid.play().then(() => {
          if (idx !== 0) {
            pauseAndResetVideo(vid);
          }
        }).catch(() => {});
      });
    }

    function bindButtons() {
      slides.forEach((slide, index) => {
        const buttons = slide.element.querySelectorAll('.slide-btn');
        if (!buttons.length) return;

        buttons.forEach((button) => {
          const buttonLink = button.dataset.buttonLink ? button.dataset.buttonLink.trim() : '';
          const variantId = button.dataset.variantId ? button.dataset.variantId.trim() : '';
          const hasAction = Boolean(variantId || buttonLink);
          if (!hasAction) {
            button.style.display = 'none';
            return;
          }

          const hasImageButton = button.dataset.buttonHasImage === 'true';
          if (!hasImageButton) {
            const buttonText = button.dataset.buttonText ? button.dataset.buttonText : DEFAULT_BUTTON_TEXT;
            button.textContent = buttonText;
          }

          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            if (variantId) {
              trackCartAdd(index, variantId);
              addToCart(variantId);
              return;
            }

            if (buttonLink) {
              trackLinkClick(index, buttonLink);
              window.location.href = buttonLink;
            }
          });
        });
      });
    }

    function initFullPage() {
      if (typeof window.jQuery === 'undefined' || typeof window.jQuery.fn.fullpage === 'undefined') {
        return;
      }

      window.jQuery(fullpageRoot).fullpage({
        scrollOverflow: true,
        onLeave: function(index, nextIndex) {
          if (index > 0) {
            trackSlideDuration(index - 1);
          }

          const prevSlide = slides[index - 1] ? slides[index - 1].element : null;
          const prevVideo = prevSlide ? prevSlide.querySelector('video') : null;

          if (prevVideo) {
            pauseAndResetVideo(prevVideo);
            const prevSrc = prevVideo.getAttribute('src');
            if (prevSrc) {
              prevVideo.setAttribute('data-src', prevSrc);
              prevVideo.removeAttribute('src');
              prevVideo.setAttribute('preload', 'none');
              prevVideo.load();
            }
          }

          const nextSlide = slides[nextIndex - 1] ? slides[nextIndex - 1].element : null;
          const nextVideo = nextSlide ? nextSlide.querySelector('video') : null;
          if (nextVideo) {
            const nextSrc = nextVideo.getAttribute('src');
            if (!nextSrc) {
              const dataSrc = nextVideo.getAttribute('data-src');
              if (dataSrc) {
                nextVideo.setAttribute('src', dataSrc);
                nextVideo.setAttribute('preload', 'auto');
                nextVideo.load();
              }
            }
            pendingPlayVideo = nextVideo;
          }
        },
        afterLoad: function(anchorLink, index) {
          if (index > 0) {
            trackSlideView(index - 1);
            updateSlideIndicator(index - 1);
          }

          const currentSlide = slides[index - 1] ? slides[index - 1].element : null;
          const currentVideo = currentSlide ? currentSlide.querySelector('video') : null;
          if (currentVideo) {
            if (!hasUserInteracted) {
              pendingPlayVideo = currentVideo;
              return;
            }
            const currentSrc = currentVideo.getAttribute('src');
            if (!currentSrc) {
              const dataSrc = currentVideo.getAttribute('data-src');
              if (dataSrc) {
                currentVideo.setAttribute('src', dataSrc);
                currentVideo.setAttribute('preload', 'auto');
                currentVideo.load();
              }
            }
            requestVideoPlay(currentVideo);
          }

          slideNodes.forEach((node) => node.classList.remove('active'));
          if (currentSlide) currentSlide.classList.add('active');
        }
      });
    }

    function initVideoControl() {
      slideNodes.forEach((target) => {
        const video = target.querySelector('video');
        if (!video) return;

        const observer = new MutationObserver(() => {
          if (target.classList.contains('active')) {
            requestVideoPlay(video);
          } else {
            pauseAndResetVideo(video);
          }
        });

        video.addEventListener('ended', () => {
          scheduleVideoReplay(video);
        });

        observer.observe(target, { attributes: true, attributeFilter: ['class'] });
      });
    }

    function trackPageUnload() {
      const activeSlide = fullpageRoot.querySelector('.swipe-lp__slide.active');
      if (!activeSlide) return;
      const activeIndex = slideNodes.indexOf(activeSlide);
      if (activeIndex >= 0) {
        trackSlideDuration(activeIndex);
      }
    }

    section.addEventListener('touchstart', markUserInteraction, { passive: true, once: true });
    section.addEventListener('click', markUserInteraction, { passive: true, once: true });
    section.addEventListener('touchend', () => {
      if (pendingPlayVideo) {
        const pendingSrc = pendingPlayVideo.getAttribute('src');
        if (!pendingSrc) {
          const dataSrc = pendingPlayVideo.getAttribute('data-src');
          if (dataSrc) {
            pendingPlayVideo.setAttribute('src', dataSrc);
            pendingPlayVideo.setAttribute('preload', 'auto');
            pendingPlayVideo.load();
          }
        }
        requestVideoPlay(pendingPlayVideo);
        pendingPlayVideo = null;
      }
    }, { passive: true });

    section.addEventListener('click', () => {
      if (pendingPlayVideo) {
        requestVideoPlay(pendingPlayVideo);
        pendingPlayVideo = null;
      }
    }, { passive: true });

    bindButtons();
    ensureSlideIndicator();
    initFullPage();
    initVideoControl();

    setTimeout(() => {
      trackSlideView(0);
      updateSlideIndicator(0);
    }, 500);

    const firstVideo = section.querySelector('.swipe-lp__slide:first-child video');
    if (firstVideo) {
      const tryAutoplay = () => {
        firstVideo.play().then(() => {
          hasUserInteracted = true;
          const videos = section.querySelectorAll('.video__wrap video');
          videos.forEach((vid, idx) => {
            if (idx === 0) return;
            const dataSrc = vid.getAttribute('data-src');
            const currentSrc = vid.getAttribute('src');
            if (!currentSrc && dataSrc) {
              vid.setAttribute('src', dataSrc);
              vid.load();
            }
            vid.play().then(() => {
              pauseAndResetVideo(vid);
            }).catch(() => {});
          });
        }).catch(() => {});
      };

      if (firstVideo.readyState >= 4) {
        tryAutoplay();
      } else {
        firstVideo.addEventListener('canplaythrough', function onCanPlay() {
          firstVideo.removeEventListener('canplaythrough', onCanPlay);
          tryAutoplay();
        });

        setTimeout(() => {
          if (!hasUserInteracted && firstVideo.paused) {
            tryAutoplay();
          }
        }, 3000);
      }
    }

    window.addEventListener('beforeunload', trackPageUnload);
    window.addEventListener('pagehide', trackPageUnload);
    }

    if (document.readyState === 'complete') {
      bootstrap();
    } else {
      window.addEventListener('load', bootstrap);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
